import { legacy_connect as connect } from 'react-redux';
import FeedbackDialog from './FeedbackDialog';
import { hideDialog, removeModuleCache, setErrorScreenMessage, setModuleCache, setScreenData, showDialog } from 'cw-ui-core';
import { ASIO_ENABLEMENT_DIALOG_ID } from '../AsioEnablementDialog/AsioEnablementDialogContainer';
import { submitFeedback } from 'src/services/AsioService';
import { FEEDBACK_RESOLVED_DIALOG_ID } from './FeedbackResolvedContainer';
import { ASIO_UPGRADE_DIALOG_ID } from '../AsioUpgrade/AsioUpgradeDialogContainer';

export const FEEDBACK_DIALOG_ID = 'FEEDBACK_DIALOG';

const mapStateToProps = state => {
  const feedbackDialog = state.dialog.get(FEEDBACK_DIALOG_ID);

  return {
    showPreviousButton: feedbackDialog?.isPreviousButtonVisible,
    returnToUpgradeDialogOnClose: feedbackDialog?.returnToUpgradeDialogOnClose
  };
};

const mapDispatchToProps = dispatch => {
  const onFeedbackSubmitClick = async () => {
    dispatch(setScreenData('isLoading', true, FEEDBACK_DIALOG_ID));
    const result = await submitFeedback();
    if (result.isSuccess) {
      dispatch(hideDialog(FEEDBACK_DIALOG_ID));
      dispatch(showDialog(FEEDBACK_RESOLVED_DIALOG_ID, { result}));
    } else {
      const errorMessage = 'Failed to create case. ';
      dispatch(hideDialog(FEEDBACK_DIALOG_ID));
      dispatch(setErrorScreenMessage(errorMessage, false, []));
    }

    dispatch(setScreenData('isLoading', false, FEEDBACK_DIALOG_ID));
  };

  return {
    // Closes the Feedback Dialog when the close button is clicked.
    onCloseIconClick: () => {
      dispatch(setModuleCache('asioDialogActiveStep', 0));
      dispatch(removeModuleCache('isFullAccountUpgrade'));
      dispatch(removeModuleCache('isAutomateInAsioUpgrade'));
      dispatch(removeModuleCache('isDefaultProvisioning'));
      dispatch(hideDialog(FEEDBACK_DIALOG_ID));
    },
    // Closes the Feedback Dialog and reopens the platform Upgrade Dialog 
    // since the user was redirected to the Feedback Dialog from the Upgrade Dialog earlier.
    onCloseClick: () => {
      dispatch(hideDialog(FEEDBACK_DIALOG_ID));
      dispatch(showDialog(ASIO_UPGRADE_DIALOG_ID));
    },
    onPreviousButtonClick: () => {
      dispatch(hideDialog(FEEDBACK_DIALOG_ID));
      dispatch(showDialog(ASIO_ENABLEMENT_DIALOG_ID));
    },
    onFeedbackSubmitClick
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackDialog);
